import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=2ead1766&scoped=true&"
import script from "./Integration.vue?vue&type=script&lang=ts&"
export * from "./Integration.vue?vue&type=script&lang=ts&"
import style0 from "./integration.scss?vue&type=style&index=0&id=2ead1766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ead1766",
  null
  
)

export default component.exports